function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.862 40.023L182.5 42l7.5 4 1-9-3.173 1.867C183.193 31.725 175.148 27 166 27c-9.337 0-17.524 4.922-22.109 12.313L141 37l.5 9 7-3-2.803-2.242C149.735 33.732 157.315 29 166 29c8.379 0 15.729 4.404 19.862 11.023zM152.968 96.07C154 100 161.241 105 169 105h2.5c4.223 0 15.45-1.56 15.5-13.5V74c0-1.728-1.508-4-3-4-1.565 0-3 1.5-3 3v9c0 .638-.383 1-1 1-.616 0-1-.362-1-1l.072-10.532c0-1.714-1.569-3.468-3.072-3.468-1.502 0-3 1.286-3 3v10c0 .638-.383 1-1 1s-1-.362-1-1V69.5c0-1.713-1.494-3-3-3-1.536 0-3 1.258-3 3V81c0 .638-.381 1-1 1-.617 0-.965-.383-.965-1.02V69.7L163 51c0-1.5-1.492-3-3-3-1.505 0-3 1.5-3 3v31.5c0 .638-.382 1-1 1-.619 0-1-.362-1-1V80c-1.219-3.46-4.375-6.712-4.671-7.017l-.022-.024c-1.539-1.864-2.889-1.398-3.772-.887-1.262.735-1.659 2.342-.96 3.792.895.834 4.759 4.788 5.709 11.652.479 3.395.652 4.624 1.684 8.554zM189 91.527v.8l.004.083.002.02a.603.603 0 01-.006.203c-.45 9.115-7.677 14.367-17.5 14.367H169c-10.914 0-16.705-6.733-17.754-9.156-1.05-2.423-1.607-5.962-2.177-10-.934-6.74-5.055-10.326-5.097-10.361l-.161-.137-.102-.188c-1.412-2.594-.652-5.713 1.728-7.1 2.363-1.37 4.693-.873 6.565 1.395l.037.044.002.002c.271.317 1.807 2.114 2.959 4.001V51c0-2.977 2.5-5 5-5s5 2.023 5 5v15c.5-1 2.007-1.5 3-1.5 1.5 0 3 0 4.591 2.63.796-.615 2.338-1.13 3.409-1.13 2.439 0 4 1 5 3.5.5-1 1.955-1.5 3-1.5 2.725 0 5 3.001 5 6v17.5a.057.057 0 010 .018v.009z",
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.862 40.023L182.5 42l7.5 4 1-9-3.173 1.867C183.193 31.725 175.148 27 166 27c-9.337 0-17.524 4.922-22.109 12.313L141 37l.5 9 7-3-2.803-2.242C149.735 33.732 157.315 29 166 29c8.379 0 15.729 4.404 19.862 11.023zM152.968 96.07C154 100 161.241 105 169 105h2.5c4.223 0 15.45-1.56 15.5-13.5V74c0-1.728-1.508-4-3-4-1.565 0-3 1.5-3 3v9c0 .638-.383 1-1 1-.616 0-1-.362-1-1l.072-10.532c0-1.714-1.569-3.468-3.072-3.468-1.502 0-3 1.286-3 3v10c0 .638-.383 1-1 1s-1-.362-1-1V69.5c0-1.713-1.494-3-3-3-1.536 0-3 1.258-3 3V81c0 .638-.381 1-1 1-.617 0-.965-.383-.965-1.02V69.7L163 51c0-1.5-1.492-3-3-3-1.505 0-3 1.5-3 3v31.5c0 .638-.382 1-1 1-.619 0-1-.362-1-1V80c-1.219-3.46-4.375-6.712-4.671-7.017l-.022-.024c-1.539-1.864-2.889-1.398-3.772-.887-1.262.735-1.659 2.342-.96 3.792.895.834 4.759 4.788 5.709 11.652.479 3.395.652 4.624 1.684 8.554zM189 91.527v.8l.004.083.002.02a.603.603 0 01-.006.203c-.45 9.115-7.677 14.367-17.5 14.367H169c-10.914 0-16.705-6.733-17.754-9.156-1.05-2.423-1.607-5.962-2.177-10-.934-6.74-5.055-10.326-5.097-10.361l-.161-.137-.102-.188c-1.412-2.594-.652-5.713 1.728-7.1 2.363-1.37 4.693-.873 6.565 1.395l.037.044.002.002c.271.317 1.807 2.114 2.959 4.001V51c0-2.977 2.5-5 5-5s5 2.023 5 5v15c.5-1 2.007-1.5 3-1.5 1.5 0 3 0 4.591 2.63.796-.615 2.338-1.13 3.409-1.13 2.439 0 4 1 5 3.5.5-1 1.955-1.5 3-1.5 2.725 0 5 3.001 5 6v17.5a.057.057 0 010 .018v.009z",
  fill: "url(#onboarding-s4_svg__paint0_linear_1513:4928)"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69 48v25H51.124s-.993-15 5.959-20C64.034 48 69 48 69 48z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69 48v25H51.124s-.993-15 5.959-20C64.034 48 69 48 69 48z",
  fill: "url(#onboarding-s4_svg__paint1_linear_1513:4928)"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.5 42l3.362-1.977C85.73 33.403 78.38 29 70 29c-8.685 0-16.265 4.732-20.303 11.758L52.5 43l-7 3-.5-9 2.89 2.313C52.477 31.922 60.664 27 70 27c9.148 0 17.193 4.724 21.827 11.867L95 37l-1 9-7.5-4zM70 47c-11.045 0-20 8.954-20 20v20c0 11.046 8.955 20 20 20 11.046 0 20-8.954 20-20V67c0-11.046-8.954-20-20-20zM52 67c0-9.606 7.524-17.454 17-17.973v10.144A3.001 3.001 0 0067 62v10H52v-5zm0 20V74h15v1a3 3 0 006 0v-1h15v13c0 9.941-8.058 18-18 18-9.94 0-18-8.059-18-18zm36-20v5H73V62a3.001 3.001 0 00-2-2.83V49.028c9.476.52 17 8.367 17 17.973zm-18-6a1 1 0 00-1 1v13a1 1 0 102 0V62a1 1 0 00-1-1z",
  fill: "#fff"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.5 42l3.362-1.977C85.73 33.403 78.38 29 70 29c-8.685 0-16.265 4.732-20.303 11.758L52.5 43l-7 3-.5-9 2.89 2.313C52.477 31.922 60.664 27 70 27c9.148 0 17.193 4.724 21.827 11.867L95 37l-1 9-7.5-4zM70 47c-11.045 0-20 8.954-20 20v20c0 11.046 8.955 20 20 20 11.046 0 20-8.954 20-20V67c0-11.046-8.954-20-20-20zM52 67c0-9.606 7.524-17.454 17-17.973v10.144A3.001 3.001 0 0067 62v10H52v-5zm0 20V74h15v1a3 3 0 006 0v-1h15v13c0 9.941-8.058 18-18 18-9.94 0-18-8.059-18-18zm36-20v5H73V62a3.001 3.001 0 00-2-2.83V49.028c9.476.52 17 8.367 17 17.973zm-18-6a1 1 0 00-1 1v13a1 1 0 102 0V62a1 1 0 00-1-1z",
  fill: "url(#onboarding-s4_svg__paint2_linear_1513:4928)"
});
var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s4_svg__paint0_linear_1513:4928",
  x1: 166,
  y1: 27,
  x2: 166,
  y2: 107,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s4_svg__paint1_linear_1513:4928",
  x1: 60,
  y1: 48,
  x2: 60,
  y2: 73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s4_svg__paint2_linear_1513:4928",
  x1: 70,
  y1: 27,
  x2: 70,
  y2: 107,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));
function SvgOnboardingS4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default SvgOnboardingS4;